@if (consent() === undefined) {
  <div class="banner">
    <p>
      We gebruiken optionele cookies om je ervaring op onze website te verbeteren.
      <button
        type="button"
        class="btn btn-link p-0 align-baseline text-decoration-none"
        (click)="moreInformationClicked()"
      >
        <i class="bi bi-info-circle"></i>
        Meer informatie
      </button>
    </p>

    <div class="buttons">
      <button type="button" class="btn btn-sm btn-primary" (click)="acceptedClicked(true)">Accepteren</button>
      <button type="button" class="btn btn-sm btn-secondary" (click)="acceptedClicked(false)">Weigeren</button>
    </div>
  </div>
}
